import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Tooltip,
} from '@mui/material';
import { packTypeOptions } from '../../../../../../data/forms/nrc/stolenAndMissingDropdownOptions';
import { yesNoOptions } from '../../../../../../data/forms/generalDropdownOptions';

export default function RhodeIslandAdditionalInfoForm({ form, handleChange }) {
  return (
    <>
      <Grid size={12}>
        <Typography
          sx={{
            fontFamily: 'BrightstarSans-Regular',
            fontSize: '16px',
            marginBottom: '15px',
          }}
        >
          Please obtain a police report to support a possible credit from the RI
          Lottery. Note: Credit is at the sole discretion of the RI Lottery.
        </Typography>
      </Grid>
      <Grid size={12}>
        <Tooltip
          title={
            'Advised The Retailer to Obtain a Police Report to Support a Possible Credit From The RI Lottery and That Credit Is At The Sole Discretion Of The RI Lottery?'
          }
          arrow
        >
          <FormControl
            required
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel
              required
              sx={{
                display: 'flex',
                alignItems: 'center',
                maxWidth: 'calc(100% - 32px)',
                '& .MuiFormLabel-asterisk': {
                  order: -1,
                  marginRight: '4px',
                  marginLeft: 0,
                },
              }}
            >
              {
                'Advised The Retailer to Obtain a Police Report to Support a Possible Credit From The RI Lottery and That Credit Is At The Sole Discretion Of The RI Lottery?'
              }
            </InputLabel>
            <Select
              required
              value={form.advisedPoliceReport || ''}
              label={
                'Advised The Retailer to Obtain a Police Report to Support a Possible Credit From The RI Lottery and That Credit Is At The Sole Discretion Of The RI Lottery?'
              }
              onChange={handleChange}
              name='advisedPoliceReport'
            >
              {yesNoOptions.map(option => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Tooltip>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormControl
          required
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Pack Type'}</InputLabel>
          <Select
            value={form.packTypes}
            label={'Pack Type'}
            onChange={handleChange}
            name='packTypes'
          >
            {packTypeOptions.map(option => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          required
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>
            {'Encouraged Retailer to Report Theft to Police'}
          </InputLabel>
          <Select
            value={form.encouragedRetailer}
            label={'Encouraged Retailer to Report Theft to Police'}
            onChange={handleChange}
            name='encouragedRetailer'
          >
            {yesNoOptions.map(option => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          label='Number of Packs Missing'
          name='packsMissing'
          required
          fullWidth
          value={form.packsMissing}
          onChange={handleChange}
          sx={{ backgroundColor: '#ffffff', marginBottom: '15px' }}
        />
        <TextField
          label='Additional Comments'
          name='comments'
          value={form.comments}
          onChange={handleChange}
          multiline
          rows={4.1}
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        />
      </Grid>
    </>
  );
}
